import ContactPageMap from "./contact-page-map";

export default ContactPageMap